module.exports = __webpack_public_path__ + "img/home-round-ups.cd9f5f21.png";